import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import grid from '../../design-language/3rd-party/flexboxgrid.module.css';
import css from './index.module.css';
import { T_SHIRT_SIZES } from '../../config'

const LayoutPageWrapper = ({ children, gridRow, horizontalPadding }) => (
  <div
    className={classnames(
      css.layoutPageWrapper,
      {
        [css[`layoutPageWrapperPaddingHorizontal${horizontalPadding}`]]: horizontalPadding,
        [grid.row]: gridRow,
      }
    )}
  >{children}</div>
);

LayoutPageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  gridRow: PropTypes.bool,
  horizontalPadding: PropTypes.oneOf(T_SHIRT_SIZES),
};

LayoutPageWrapper.defaultProps = {
  gridRow: false,
  horizontalPadding: null,
};

export default LayoutPageWrapper;
